<template>
  <div class="Loading cover_white flex-c">
    <div class="col-12 t-c">
      <div class="col-12 mb10"><img src="../assets/loading.gif" class="w5"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loading'
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue